import React from "react";
import Lodaer from "../assest/images/loader.gif";

const Loader = () => {
  return (
    <div className="app-loader">
      <div className="loader-overlay">
        <div className="spinner-ring"></div>
        {/* <img src={Lodaer} alt="Loading..." className="loader-gif" /> */}
        <div className="loader-text">Loading ...</div>
      </div>
    </div>
  );
};

export default Loader;
